import type {Component} from 'typings/portaro.fe.types';
import type {IOnInit} from 'angular';
import type SdiRequestsDataService from '../../data-services/sdi-requests.data-service';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {SdiRequest} from 'typings/portaro.be.types';

export class KpSdiRequestsPanelComponentController implements KpSdiRequestsPanelComponentBindings, IOnInit {
    public userId: number;
    public requests: SdiRequest[];

    /*@ngInject*/
    constructor(private sdiRequestsDataService: SdiRequestsDataService) {
    }

    @ngAsync()
    public async $onInit() {
        this.requests = await this.sdiRequestsDataService.query(this.userId);
    }
}

/**
 * @ngdoc component
 * @name kpSdiRequestsPanel
 * @module portaro.components
 *
 * @param {number} userId User id.
 *
 * @description
 * Show all user SDI requests in panel.
 */
export default class KpSdiRequestsPanelComponent implements Component<KpSdiRequestsPanelComponentBindings> {
    public static componentName = 'kpSdiRequestsPanel';

    public templateUrl = require('./kp-sdi-requests-panel.tpl.ftl');

    public bindings = {
        userId: '<'
    } as const;

    public controller = KpSdiRequestsPanelComponentController;
}

interface KpSdiRequestsPanelComponentBindings {
    userId: number;
}
